export class ResendApteringspaketRequestDTO   {

    maskinId: number;
    maskinnummer: string;
    maskinTyp: string;
    resendArbetsorderCorrelationGuid?: string;

    resendDependenciesCorrelationGuid?: string;

    constructor() {
        this.maskinId = undefined;
        this.maskinnummer = undefined;
        this.maskinTyp = undefined;
        this.resendArbetsorderCorrelationGuid = undefined;
        this.resendDependenciesCorrelationGuid = undefined;
    }
}
